export default __webpack_public_path__ + "files/19ed0de6891b8c433bfb3058d11499f6.mp3";